function setFlipHeight() {
  document.querySelectorAll('.flip-transition').forEach((flip) => {
    const flipInner = flip.querySelector('.multicolumn-card__heading-card'); 
    const flipInnerContent = flip.querySelector('.multicolumn-card__heading--inner .inner-container');
    const flipInnerHeight = flipInnerContent.offsetHeight + 24;
    flipInner.style.height = flipInnerHeight + 'px';
  });
}
function togglePrice() {
  document.querySelectorAll('.custom-price-tables .toggle').forEach((toggle) => {
    const toggleRadios = toggle.querySelectorAll('.toggle_option[type="radio"]');
    
    toggleRadios.forEach((radio) => {
      radio.addEventListener('change', (event) => {
        if(event.target.checked) {
          const sectionId = event.target.getAttribute('section');
          const selectedOption = event.target.value;
          const toggleContent = document.querySelectorAll('.toggle_section-' + sectionId + ' .multicolumn-card__heading--inner');
          const contentContainer = document.querySelectorAll('.toggle_section-' + sectionId);
          const toggleInfo = document.querySelectorAll('.toggle_info_section-' + sectionId + ' .multicolumn-card__info-container');
          setFlipHeight();
          if (selectedOption === 'option_2') {
            contentContainer.forEach((content) => {
              content.classList.add('flipped');
            })
          } else {
            contentContainer.forEach((content) => {
              content.classList.remove('flipped');
            })
          }
          toggleContent.forEach((content) => {
            if (content.classList.contains('heading__' + selectedOption)) {
              content.classList.remove('hide');
            } else {
              content.classList.add('hide');
            }
          });
          toggleInfo.forEach((info) => {
            if (info.classList.contains('info__' + selectedOption)) {
              info.classList.remove('hide');
            } else {
              info.classList.add('hide');
            }
          });
        }
      });
    });
  });
  document.querySelectorAll('.custom-price-tables-v2 .toggle').forEach((toggle) => {
    const toggleRadios = toggle.querySelectorAll('.toggle_option[type="radio"]');
    
    toggleRadios.forEach((radio) => {
      radio.addEventListener('change', (event) => {
        if(event.target.checked) {
          const sectionId = event.target.getAttribute('section');
          const selectedOption = event.target.value;
          const toggleContent = document.querySelectorAll('.toggle_section-' + sectionId + ' .multicolumn-card__heading--inner');
          const contentContainer = document.querySelectorAll('.toggle_section-' + sectionId);
          if (selectedOption === 'option_2') {
            contentContainer.forEach((content) => {
              content.classList.add('flipped');
            })
          } else {
            contentContainer.forEach((content) => {
              content.classList.remove('flipped');
            })
          }
          toggleContent.forEach((content) => {
            if (content.classList.contains('heading__' + selectedOption)) {
              content.classList.remove('hide');
            } else {
              content.classList.add('hide');
            }
          });
        }
      });
    });
  });
}
function initializeContent() {
  document.querySelectorAll('.custom-price-tables .toggle').forEach((toggle) => {
    const toggleRadios = toggle.querySelectorAll('.toggle_option[type="radio"]');

    toggleRadios.forEach((radio) => {
      if(radio.checked) {
        const sectionId = radio.getAttribute('section');
        const selectedOption = radio.value;
        const toggleContent = document.querySelectorAll('.toggle_section-' + sectionId + ' .multicolumn-card__heading--inner');
        const contentContainer = document.querySelectorAll('.toggle_section-' + sectionId);
        const toggleInfo = document.querySelectorAll('.toggle_info_section-' + sectionId + ' .multicolumn-card__info-container');
        
        setFlipHeight();

        if (selectedOption === 'option_2') {
          contentContainer.forEach((content) => {
            content.classList.add('flipped');
          })
        } else {
          contentContainer.forEach((content) => {
            content.classList.remove('flipped');
          })
        }

        toggleContent.forEach((content) => {
          if (content.classList.contains('heading__' + selectedOption)) {
            content.classList.remove('hide');
          } else {
            content.classList.add('hide');
          }
        });

        toggleInfo.forEach((info) => {
          if (info.classList.contains('info__' + selectedOption)) {
            info.classList.remove('hide');
          } else {
            info.classList.add('hide');
          }
        });
      }
    });
  });
  document.querySelectorAll('.custom-price-tables-v2 .toggle').forEach((toggle) => {
    const toggleRadios = toggle.querySelectorAll('.toggle_option[type="radio"]');

    toggleRadios.forEach((radio) => {
      if(radio.checked) {
        const sectionId = radio.getAttribute('section');
        const selectedOption = radio.value;
        const toggleContent = document.querySelectorAll('.toggle_section-' + sectionId + ' .multicolumn-card__heading--inner');
        const contentContainer = document.querySelectorAll('.toggle_section-' + sectionId);
        if (selectedOption === 'option_2') {
          contentContainer.forEach((content) => {
            content.classList.add('flipped');
          })
        } else {
          contentContainer.forEach((content) => {
            content.classList.remove('flipped');
          })
        }

        toggleContent.forEach((content) => {
          if (content.classList.contains('heading__' + selectedOption)) {
            content.classList.remove('hide');
          } else {
            content.classList.add('hide');
          }
        });
      }
    });
  });
}
async function memberCount() {
  if (window.shopUrl) {
    const shopURL = window.shopifyUrl;
    const response = await fetch("https://uncommon-assets-dev-92e02c68358e.herokuapp.com/api/user-count?shopName=" + shopURL, {
      method: "GET",
      headers: {
        token: "98srtngtrsni9kr7832hu"
      }
    }).then(d => d.json());
    var activeUsers = response.data.activeUsers;
    window.activeUsers = activeUsers;
    document.querySelectorAll('.member-count').forEach((count) => {
      count.innerHTML = activeUsers;
    });
  } else {
    console.log("shopURL is undefined");
  }
}
document.addEventListener("DOMContentLoaded", function() {
  initializeContent();
  setFlipHeight();
  togglePrice();
  memberCount();
  window.addEventListener('resize', function() {
    setFlipHeight();
  });
  document.addEventListener('shopify:block:select', function (event) {
    setFlipHeight();
    togglePrice();
    memberCount();    
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    setFlipHeight();
    togglePrice();
    memberCount();
  });
  document.addEventListener('shopify:section:load', function (event) {
    setFlipHeight();
    togglePrice();
    memberCount();
  });
  document.addEventListener('shopify:section:reorder', function (event) {
    setFlipHeight();
    togglePrice();
    memberCount();
  });
  document.addEventListener('shopify:section:select', function (event) {
    setFlipHeight();
    togglePrice();
    memberCount();
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    setFlipHeight();
    togglePrice();
    memberCount();
  });
  document.addEventListener('shopify:inspector:activate', function (event) {
    setFlipHeight();
    togglePrice();
    memberCount();
  });  
  document.addEventListener('shopify:inspector:deactivate', function (event) {
    setFlipHeight();
    togglePrice();
    memberCount();
  });
});
window.onload=function() {
  initializeContent();
  setFlipHeight();
  togglePrice();
  memberCount();
}

// // listen for cart changes. Look at any products with type "Membership Addon". If present, check for products of type "Membership" with a matching line item property value for key "__addonID". If no matching "Membership" product is found, remove the "Membership Addon" product from the cart.
// document.addEventListener('cart:updated', function(event) {
//   const cart = event.detail;
//   const membershipAddons = cart.items.filter(item => item.product_type === 'Membership Addon');
//   const memberships = cart.items.filter(item => item.product_type === 'Membership');
//   membershipAddons.forEach(addon => {
//     const addonID = addon.properties.find(property => property.name === '__addonID').value;
//     const matchingMembership = memberships.find(membership => {
//       return membership.properties.find(property => property.name === '__addonID' && property.value === addonID);
//     });
//     if (!matchingMembership) {
//       fetch(`/cart/change.js?line=${addon.key}&quantity=0`, { method: 'POST' });
//     }
//   });
// });